import Model, { hasMany } from '@warp-drive/legacy/model';
import type TasFieldModel from './tas-field.ts';

export default class Fieldable extends Model {
  /*************************
   **  Relationships      **
   *************************/
  @hasMany('tas-field', {
    async: false,
    inverse: 'fieldable',
    as: 'fieldable',
  })
  declare tasFields: TasFieldModel[];
}
